// extracted by mini-css-extract-plugin
export default {"MerchantReportContent":"MerchantReport_MerchantReportContent__M83TS","teamTitle":"MerchantReport_teamTitle__3GwHq","backBtn":"MerchantReport_backBtn__SeQ94"};